export default __webpack_public_path__ + "static/media/chart.1df2e814.svg";